import styled from 'styled-components'
import { notifyFadeIn, notifyFadeOut } from '../../../animations/Transitions'
import { cyberColors } from '../../../lib/colors'

interface form_style_props {
  error?: boolean
  fadeOut?: boolean
  fadein?: boolean
}
export const NotifyWrapper = styled.div<form_style_props>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  z-index: 2;
  //animation
  ${notifyFadeIn}
  ${({ fadeOut }) => fadeOut && notifyFadeOut}
  animation-duration: ${({ fadeOut }) => (fadeOut ? '0.24s' : '0.55s')};
  p {
    background: ${({ error }) =>
      error ? cyberColors.redGradient : cyberColors.greenGradient};
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    clip-path: inset(1px 0.5px);
    font-size: 12px;
    text-transform: uppercase;
  }
`
